import PartnerBanks from "@/components/landing/PartnerBanks";
import { useCallback } from "react";
import SEO from "@/components/common/SEO";
import { LOAN_TYPES } from "@/constants/loanTypes";

import LoanLayout from "@/components/loans/LoanLayout";
import LoanHero from "@/components/loans/LoanHero";
import LoanOverview from "@/components/loans/LoanOverview";
import LoanBenefits from "@/components/loans/LoanBenefits";
import LoanTypes from "@/components/loans/LoanTypes";
import LoanEligibility from "@/components/loans/LoanEligibility";
import LoanDocuments from "@/components/loans/LoanDocuments";
import LoanProcess from "@/components/loans/LoanProcess";
import WhyMoneyMart from "@/components/loans/WhyMoneyMart";
import LoanFAQ from "@/components/loans/LoanFAQ";
import LoanCTA from "@/components/loans/LoanCTA";
import LeadFormSection from "@/components/loans/LeadFormSection";

import { personalLoan } from "@/data/loans";

const PersonalLoan = () => {
  const scrollToLeadForm = useCallback(() => {
    const el = document.getElementById("lead-form");

    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, []);
  return (
    <>
      <SEO {...personalLoan.seo} />
      <LoanLayout onCtaClick={scrollToLeadForm}>
        <LoanHero
          {...personalLoan.hero}
          onPrimaryClick={scrollToLeadForm}
          onSecondaryClick={scrollToLeadForm}
        />

        <LoanOverview {...personalLoan.overview} />

        <LoanBenefits {...personalLoan.benefits} />

        <LoanTypes {...personalLoan.types} />

        <LoanEligibility
          {...personalLoan.eligibility}
          onCheckEligibility={scrollToLeadForm}
        />

        <LoanDocuments {...personalLoan.documents} />

        <LoanProcess {...personalLoan.process} />

        <WhyMoneyMart {...personalLoan.whyMoneyMart} />

        <PartnerBanks />

        <LoanFAQ {...personalLoan.faq} />

        <LoanCTA {...personalLoan.cta} onApply={scrollToLeadForm} />

        <LeadFormSection
          {...personalLoan.leadForm}
          loanType="PERSONAL_LOAN"
        />
      </LoanLayout>
    </>
  );
};

export default PersonalLoan;
